"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const submit_button_type_1 = require("@App/enum/submit-button-type");
const SubmitButton = (props) => {
    const { mainColor = true, type = submit_button_type_1.SubmitButtonType.primary, className, label, disabled } = props;
    const classNames = (0, clsx_1.default)(mainColor ? 'main-color-set' : 'second-color-set', type, className, disabled && 'disabled');
    return (react_1.default.createElement("div", { className: `submit-button-component ${classNames}` },
        react_1.default.createElement("input", { className: classNames, type: "submit", value: label, disabled: disabled })));
};
exports.default = SubmitButton;
